module.exports = __webpack_public_path__ + "static/img/fail.bd8adc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/fail.png
// module id = dpq6
// module chunks = 1